export default __webpack_public_path__ + "static/media/mtn_khava.10879208.jpg";